window.Products.WallArt = {

};
window.Products.WallArt.WallArt = function() {
	
};
window.Products.WallArt.WallArt.inherits(window.Products.Product);

window.Products.WallArt.WallArt.dpi = 300;

window.Products.WallArt.WallArt.minDPIs = {
	'1-1': {
		'8x8' 		: 66.7,
		'12x12' 	: 100,
		'16x16' 	: 133.3,
		'20x20' 	: 166.7,
		'24x24' 	: 200
	},
	'2-3': {
		'8x12' 		: 80,
		'12x18' 	: 120,
		'16x24' 	: 160,
		'20x30' 	: 200
	},
	'3-4': {
		'7_5x10'	: 62.5,
		'12x16' 	: 100,
		'18x24' 	: 150,
		'24x32' 	: 200
	},
	'3-2': {
		'12x8' 		: 80,
		'18x12' 	: 120,
		'24x16' 	: 160,
		'30x20' 	: 200
	},
	'4-3': {
		'10x7_5'	: 62.5,
		'16x12' 	: 100,
		'24x18' 	: 150,
		'32x24' 	: 200
	},
	'8x10' 			: 200,
	'10x8' 			: 200,
	'12x12' 		: 100,
	'11x14' 		: 200,
	'14x11' 		: 200,
	'12x16' 		: 100,
	'16x12' 		: 100,
	'16x16' 		: 200,
	'12x18' 		: 120,
	'18x12' 		: 120,
	'16x20' 		: 200,
	'20x16' 		: 200,
	'20x24' 		: 200,
	'24x20' 		: 200
};

window.Products.WallArt.WallArt.prototype.getMinDPI = function(variant){
	return window.Products.WallArt.WallArt.minDPIs[variant];
};

window.Products.WallArt.WallArt.prototype.getUnavailableVariants = function(variant, dpi){
	var unavailable = [];

	var target = this.getMinDPI(variant);
	if(typeof target != 'number'){
		for(var key in target){
			if(target.hasOwnProperty(key)){
				if(dpi + 1 < target[key]){
					unavailable.push(key);
				}
			}
		}
	} else {
		if(dpi + 1 < target){
			unavailable.push(variant);
		}
	}

	return unavailable;
};